import React from 'react';
import {
  Box,
  Card,
  CardActionArea,
  Typography,
  Grid,
  Container,
  Avatar,
  Fade
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DescriptionIcon from '@mui/icons-material/Description';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

// Module configuration
const modules = [
  {
    title: 'Implant Report',
    icon: <DescriptionIcon sx={{ fontSize: 60 }} />,
    path: '/implant',
    color: '#1976d2', // Primary Blue
  },
  {
    title: 'Impaction Report',
    icon: <AssessmentIcon sx={{ fontSize: 60 }} />,
    path: '/impaction',
    color: '#ed6c02', // Warning Orange
  },
  {
    title: 'New Module',
    icon: <AddCircleOutlineIcon sx={{ fontSize: 60 }} />,
    path: '#',
    color: '#9e9e9e', // Grey
    disabled: true
  }
];

function HomePage() {
  const navigate = useNavigate();

  return (
    <Box sx={{
      minHeight: '100vh',
      bgcolor: '#f4f6f8',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      py: 4
    }}>
      <Container maxWidth="xl">
        {/* Header Section */}
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <img
            src="/orald_logo.png"
            alt="Orald Logo"
            style={{ height: '60px', marginBottom: '24px' }}
            onError={(e) => { e.target.style.display = 'none'; }}
          />
          <Typography
            variant="h4"
            component="h1"
            sx={{
              fontWeight: 600,
              color: '#1a237e',
              letterSpacing: '1px',
              textTransform: 'uppercase'
            }}
          >
            Select Module
          </Typography>
        </Box>

        {/* Modules Grid - Single Row Centered */}
        <Grid
          container
          spacing={4}
          justifyContent="center"
          alignItems="center"
        >
          {modules.map((module, index) => (
            <Grid item key={index}>
              <Fade in={true} timeout={500 + (index * 200)}>
                <Card
                  sx={{
                    width: 280,
                    height: 280,
                    borderRadius: 6, // Very rounded corners
                    boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    position: 'relative',
                    overflow: 'visible',
                    opacity: module.disabled ? 0.7 : 1,
                    '&:hover': {
                      transform: module.disabled ? 'none' : 'translateY(-12px)',
                      boxShadow: module.disabled ? 'none' : '0 20px 60px rgba(0,0,0,0.15)',
                    }
                  }}
                >
                  <CardActionArea
                    onClick={() => !module.disabled && navigate(module.path)}
                    disabled={module.disabled}
                    sx={{
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      p: 2
                    }}
                  >
                    {/* Floating Icon Background */}
                    <Box
                      sx={{
                        position: 'absolute',
                        top: '15%',
                        width: 120,
                        height: 120,
                        borderRadius: '50%',
                        bgcolor: `${module.color}10`, // Very light opacity background
                        filter: 'blur(20px)',
                        zIndex: 0
                      }}
                    />

                    {/* Main Icon */}
                    <Avatar
                      sx={{
                        width: 90,
                        height: 90,
                        bgcolor: 'transparent',
                        color: module.color,
                        mb: 3,
                        zIndex: 1
                      }}
                    >
                      {module.icon}
                    </Avatar>

                    {/* Title */}
                    <Typography
                      variant="h5"
                      component="div"
                      sx={{
                        fontWeight: 600,
                        color: '#34495e',
                        textAlign: 'center',
                        zIndex: 1
                      }}
                    >
                      {module.title}
                    </Typography>
                  </CardActionArea>
                </Card>
              </Fade>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default HomePage;
